module.exports = __webpack_public_path__ + "ikea_assets.png?ce3b1f6a3ac9db6d2fe9a51a704543a2";


//////////////////
// WEBPACK FOOTER
// ./static/ikea_assets.png
// module id = 358
// module chunks = 0